<template>
    <div class="">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-copy"></i> 消息中心</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <!-- <el-tabs v-model="message">
                <el-tab-pane :label="`未读消息(${todoList.length})`" name="first"> -->
            <el-table :data="todoList" :show-header="false" style="width: 100%">
                <el-table-column>
                    <template slot-scope="scope">
                        <span :class="scope.row.is_read == 0 ? 'message-title' : ''">{{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_addtime" width="180"></el-table-column>
                <el-table-column width="120">
                    <template slot-scope="scope">
                        <el-button size="small" @click="handleRead(scope)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="handle-row">
                        <el-button type="primary">全部标为已读</el-button>
                    </div> -->
            <!-- </el-tab-pane> -->
            <!-- <el-tab-pane :label="`已读消息(${read.length})`" name="second">
                    <template v-if="message === 'second'">
                        <el-table :data="read" :show-header="false" style="width: 100%">
                            <el-table-column>
                                <template slot-scope="scope">
                                    <span class="message-title">{{scope.row.title}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" width="150"></el-table-column>
                            <el-table-column width="120">
                                <template slot-scope="scope">
                                    <el-button type="danger" @click="handleDel(scope.$index)">{{ $t('common.delete') }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="handle-row">
                            <el-button type="danger">删除全部</el-button>
                        </div>
                    </template>
                </el-tab-pane> -->
            <!-- <el-tab-pane :label="`回收站(${recycle.length})`" name="third">
                    <template v-if="message === 'third'">
                        <el-table :data="recycle" :show-header="false" style="width: 100%">
                            <el-table-column>
                                <template slot-scope="scope">
                                    <span class="message-title">{{scope.row.title}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="date" width="150"></el-table-column>
                            <el-table-column width="120">
                                <template slot-scope="scope">
                                    <el-button @click="handleRestore(scope.$index)">还原</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="handle-row">
                            <el-button type="danger">清空回收站</el-button>
                        </div>
                    </template>
                </el-tab-pane> -->
            <!-- </el-tabs> -->
        </div>
        <el-dialog style="padding:0 20px" title="详情" :visible.sync="outData.isshow" width="60%">
            <el-form class="editda" label-width="100px">
                <el-form-item label="发布人：">
                    <span v-text="outData.data.send_user_no"></span>
                </el-form-item>
                <el-form-item label="时间：">
                    <span v-text="outData.data.send_addtime"></span>
                </el-form-item>
                <el-form-item label="标题：">
                    <span v-text="outData.data.title"></span>
                </el-form-item>
                <el-form-item label="内容：">
                    <span v-html="outData.data.content"></span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="outData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Utils from '../../assets/util.js';
import { apiNoticeIndex, apiNoticeDetail } from '@/request/api';
export default {
    name: 'tabs',
    data() {
        return {
            todoList: [],
            outData: { isshow: false, scope: null, index: 0, data: {} },
            message: 'first',
            showHeader: false,
            unread: [
                {
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护'
                },
                {
                    date: '2018-04-19 21:00:00',
                    title: '今晚12点整发大红包，先到先得'
                }
            ],
            read: [
                {
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护'
                }
            ],
            recycle: [
                {
                    date: '2018-04-19 20:00:00',
                    title: '【系统通知】该系统将于今晚凌晨2点到5点进行升级维护'
                }
            ]
        };
    },
    created() {
        this.getNotice();
    },
    methods: {
        // handleRead(index) {
        //     const item = this.unread.splice(index, 1);
        //
        //     this.read = item.concat(this.read);
        // },
        handleDel(index) {
            const item = this.read.splice(index, 1);
            this.recycle = item.concat(this.recycle);
        },
        handleRestore(index) {
            const item = this.recycle.splice(index, 1);
            this.read = item.concat(this.read);
        },
        getNotice() {
            apiNoticeIndex({
                type: '全部公告'
            }).then(res => {
                if (res.code == 2000) {
                    this.todoList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleRead(scope) {
            this.outData.isshow = true;
            scope.row.is_read = 1;
            apiNoticeDetail({
                id: scope.row.send_id,
                send_type: this.$bus.data.type
            }).then(res => {
                if (res.code == 2000) {
                    this.outData.data = res.data;
                    Utils.$emit('demo', 'msg');
                } else {
                    this.$message.error(res.msg);
                }
            });
        }
    },
    computed: {
        unreadNum() {
            return this.unread.length;
        }
    }
};
</script>

<style>
.message-title {
    cursor: pointer;
}
.handle-row {
    margin-top: 30px;
}
</style>
